import { Gallery } from '../components/Gallery.jsx';
import { siteLinks } from '../data.js';

export function MediaPage() {
  return (
    <>
      <header className="page-hero page-width">
        <div>
          <p className="eyebrow">Mainstream media</p>
          <h1>Receipts from Christmases past.</h1>
        </div>
        <p>LAmestrEam media</p>
      </header>

      <div className="page-width">
        <Gallery />
      </div>

      <section className="media-embeds page-width section-pad">
        <article>
          <div className="embed-label"><span>01</span> Watch</div>
          <div className="embed-frame video-frame">
            <iframe
              src={siteLinks.youtubeUrl}
              title="Uncle Mike Ruins Christmas video"
              loading="lazy"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div>
        </article>
        <article>
          <div className="embed-label"><span>02</span> Listen</div>
          <div className="embed-frame spotify-frame">
            <iframe
              src={siteLinks.spotifyUrl}
              title="Uncle Mike Ruins Christmas Spotify playlist"
              loading="lazy"
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            />
          </div>
        </article>
      </section>
    </>
  );
}
